import React, {Component} from 'react';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import MenuItem from "@material-ui/core/MenuItem";
import AsyncAutocomplete from "./AsyncAutocomplete";
import {getTimesToCall} from "../services/actions";
import Modal from "@material-ui/core/Modal";
import moment from "moment";
import Button from "@material-ui/core/Button";
import Search from "./SearchBar";
import {withTranslation,Trans} from "react-i18next";
import {isRtl} from "../services/Helpers";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";


class InputWrapper extends Component {
    constructor(props) {
        super(props);
        const {t} = this.props
        this.state = {
            isMobile: window.innerWidth,
            showDatePicker: false,
            timesToCall: [],
            selectedTime: {Hour: "11:58", description: t('now'), Type: -1, TextToShow: t('now'), value: null}
        }
    }

    handleWindowSizeChange = () => {
        this.setState({isMobile: window.innerWidth})
    }

    componentDidMount = async () => {
        const {country} = this.props
        let timesToCall = await getTimesToCall(country);
        if (timesToCall)
            this.setState({timesToCall, selectedTime: timesToCall[0]})
        window.addEventListener('resize', this.handleWindowSizeChange);
    }


    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.emptyForm !== this.props.emptyForm && this.props.emptyForm === true) {
            this.setState({emptyForm: true})
        }
    }

    render() {
        let {icon, placeholder, type, source, updateForm, formID, country} = this.props;
        let {timesToCall} = this.state;
        const {t,i18n} = this.props
        return (
            <div className={"input-wrapper"}>
                <div className={"input-icon"} style={isRtl() ? {marginLeft:'10px'} : {marginRight:'10px'}}>
                    {icon}
                </div>

                {type === "autoComplete" &&
                <div className={"input-field white"} style={
                    this.props.isRequired && (this.props.showRequired || (formID == "phoneNumber" && this.props.showPhoneErr)) ?
                        {border: "2px solid red"} : {}
                }>
                    <AsyncAutocomplete
                        placeholder={t(placeholder)}
                        source={source}
                        updateForm={updateForm}
                        formID={formID}
                        serviceSubject={this.props.serviceSubject}
                    />
                </div>
                }
                {type === "searchBar" &&
                <div className={"input-field white"} id="AddressContainer" style={
                    this.props.isRequired && (this.props.showRequired || (formID == "serviceAreaName" && this.props.showLondonErr)) ?
                        {border: "2px solid red"} : {}
                }>
                    <Search
                        placeholder={t(placeholder)}
                        updateForm={updateForm}
                        formID={formID}
                        countryAlpha2={country.Alpha2}
                        serviceAreaName={this.props.serviceAreaName}
                    />
                </div>
                }
                {type === "freeText" &&
                <div className={"input-field white"} style={
                    this.props.isRequired && (this.props.showRequired || (formID == "phoneNumber" && this.props.showPhoneErr)) ?
                        {border: "2px solid red"} : {}}>
                    <TextField
                        placeholder={t(placeholder)}
                        variant="outlined"
                        fullWidth
                        onChange={(event) => {
                            this.setState({value: event.target.value})
                            updateForm(formID, event.target.value)
                        }}
                        type={this.props.inputType ? this.props.inputType : null}
                        value={this.state.value}
                    />
                </div>
                }
                {type === "select" &&
                <div className={"input-field select-container"}>
                    {/*<TextField
                        id="outlined-basic"
                        //label={t(placeholder)}
                        disabled={true}
                        //variant="standard"
                        />*/}
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={this.state.selectedTime}
                        autoWidth={true}
                        className={"select-field"}
                        onChange={(event) => {
                            if (event.target.value.TextToShow === t('other')) {
                                this.setState({showDatePicker: true,})
                            } else {
                                this.setState({selectedTime: event.target.value})
                                updateForm(formID, event.target.value)
                            }
                        }}
                    >
                        {timesToCall.map((item, key) =>
                            <MenuItem key={key} value={item}>{t(item.key)} {item.TextToShow}</MenuItem>
                        )}
                        <MenuItem
                            key={100}
                            value={{Hour: "00:00", description:t('other'), Type: -1, TextToShow: t('other'), value: null}

                            }>{t('other')}
                        </MenuItem>
                    </Select>
                </div>
                }
                {type === "freeText2" &&
                <div className={"input-field problem-field"}>
                    <TextField
                        id="outlined-basic"
                        placeholder={t(placeholder)}
                        variant="standard"
                        value={this.state.value}
                        onChange={(event) => {
                            this.setState({value: event.target.value})
                            updateForm(formID, event.target.value)
                        }}
                    />
                </div>
                }
                <Modal className={"modal-container"} open={this.state.showDatePicker}>
                    <form className={"datepicker-modal"} noValidate>
                        <div className={"modal-header"}>
                            {t('customDate')}
                        </div>
                        <DatePicker
                            selected={this.state.selectedTime.value || new Date()}
                            minDate={new Date()}
                            shouldCloseOnSelect={true}
                            popperPlacement={`${this.state.isMobile < 530? "bottom-start" : "right"}`}
                            onChange={(date) => {
                                let {selectedTime, timesToCall} = this.state;
                                let curDate = {...selectedTime}
                                curDate.TextToShow = country && country.Id === 1? moment(date).format("DD/MM/YYYY, HH:mm") : moment(date).format("DD/MM/YYYY, HH:mm a");
                                curDate.value = date.getTime();
                                curDate.key = '';
                                timesToCall.push(curDate)
                                this.setState({selectedTime: curDate, timesToCall})
                            }}
                            timeInputLabel="Time:"
                            dateFormat={`${country && country.Id === 1 ? "dd/MM/yyyy HH:mm" : "dd/MM/yyyy hh:mm a"}`}
                            showTimeInput
                        />
                        {this.state.showInvalidDateErr &&
                        <div style={{color: "red"}}>
                            Please choose a valid date
                        </div>}
                        <Button
                            variant="contained"
                            size="large"
                            className={""}
                            onClick={() => {
                                if (moment(this.state.selectedTime.value).isBefore(moment())) {
                                    this.setState({showInvalidDateErr: true})
                                    return;
                                } else {
                                    this.setState({showDatePicker: false, showInvalidDateErr: false})
                                    updateForm(formID, this.state.selectedTime)
                                }
                            }
                            }
                        >
                            {t('save')}
                        </Button>
                    </form>
                </Modal>
            </div>
        );
    }
}

export default withTranslation('translation')(InputWrapper);
